<ng-container
  *ngIf="{
    responseId: responseId$ | async,
    isConf: isConf$ | async
  } as data"
>
  <cng-contact-view-layout>
    <ng-template cngContactViewLayoutActions>
      <chat-transfer-actions [responseId]="data.responseId" [isConference]="data.isConf"></chat-transfer-actions>
    </ng-template>
    <ng-template cngContactViewLayoutWorkspace>
      <chat-transfer-workspace [responseId]="data.responseId" [isConference]="data.isConf"></chat-transfer-workspace>
    </ng-template>
  </cng-contact-view-layout>
</ng-container>
